module.exports = __webpack_public_path__ + "assets/img/login-right-bg.71d7a7e4.png";